import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20artistic%20composition%20with%20soft%20flowing%20silk-like%20shapes%20in%20warm%20rose%20gold%20cream%20and%20beige%20tones%2C%20luxurious%20texture%2C%20dreamy%20ethereal%20atmosphere%2C%20minimalist%20elegant%20aesthetic%2C%20high%20quality%20abstract%20wallpaper%2C%20soft%20gradients%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="AI美女生成平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            一键创作专属
            <br />
            <span className="text-accent-400">AI美女</span>形象
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-10 max-w-xl mx-auto leading-relaxed">
            顶级AI图像生成技术，轻松生成高颜值AI美女写真、头像与壁纸。
            无需设计基础，输入描述即可秒出精美AI美女图像。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 text-base bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer font-medium shadow-lg shadow-primary-500/30"
            >
              免费开始创作
            </Link>
            <Link
              to="/category/ai-meinv-xiezhen"
              className="px-8 py-3.5 text-base bg-white/15 backdrop-blur-sm text-white rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
            >
              浏览作品画廊
            </Link>
          </div>
          <div className="mt-12 flex items-center justify-center gap-8 text-white/60">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">
                50万+
              </p>
              <p className="text-xs md:text-sm mt-1">已生成图像</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">
                10万+
              </p>
              <p className="text-xs md:text-sm mt-1">活跃用户</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">
                4.9
              </p>
              <p className="text-xs md:text-sm mt-1">用户评分</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}